import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { AssessmentProvider } from "./context/AssessmentContext";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import WhyUs from "./pages/WhyUs";
import Contact from "./pages/Contact";
import AssessmentHub from "./pages/AssessmentHub";
import AssessmentModule from "./pages/AssessmentModule";
import AssessmentResults from "./pages/AssessmentResults";
import Insights from "./pages/Insights";
import InsightDetail from "./pages/InsightDetail";
import GrowthReadiness from "./pages/GrowthReadiness";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function App() {
  return (
    <AssessmentProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App relative">
          <Navbar />
          <main className="min-h-screen">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/why-us" element={<WhyUs />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/assessment" element={<AssessmentHub />} />
              <Route path="/assessment/:slug" element={<AssessmentModule />} />
              <Route path="/assessment/:slug/results" element={<AssessmentResults />} />
              <Route path="/growth-readiness" element={<GrowthReadiness />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<InsightDetail />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </AssessmentProvider>
  );
}

export default App;
